export type Appearance = 'light' | 'dark'
const storageKey = 'shenbi-appearance'
export function readAppearance(): Appearance {
  try {
    const saved = localStorage.getItem(storageKey)
    if (saved === 'light' || saved === 'dark') return saved
    const legacy = localStorage.getItem('vueuse-color-scheme')
    if (legacy === 'light' || legacy === 'dark') return legacy
    if (legacy === 'auto') return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  } catch { /* Storage unavailable: usable light default. */ }
  return 'light'
}
export function applyAppearance(value: Appearance): void {
  document.documentElement.classList.toggle('dark', value === 'dark')
  document.documentElement.style.colorScheme = value
  try { localStorage.setItem(storageKey, value) } catch { /* Keep in-memory preference. */ }
}
